import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Dialog,
  AppBar,
  IconButton,
  Slide,
  Paper} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import PrintComponentAcertoCoparticipacao from './PrintComponentAcertoCoparticipacao';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  toolbar: {
    display: 'flex',
    backgroundColor: '#5c6bc0',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing.unit * 2,
  },
  flex: {
    flex: 1,
  },
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 15,
    paddingBottom: theme.spacing.unit * 15,
    margin: theme.spacing.unit * 2,
  },
});

function Transition (props) {
  return <Slide direction='left' {...props} />;
}

class FullScreenPrintAcertoPagAntecipado extends React.Component {
  render () {
    const { classes, open, handleClose, acerto } = this.props;
    return (
      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          scroll='paper'
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Paper square elevation={0} className={classes.toolbar} onClick={handleClose} color='inherit'>
              <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
                <ClearIcon />
              </IconButton>
            </Paper>
          </AppBar>
          <PrintComponentAcertoCoparticipacao acerto={acerto} />
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(FullScreenPrintAcertoPagAntecipado);
